import { OryxGameView } from "@westpierstudio/core-module-oryx/game";
import { GameServices } from "./GameServices";

export class PrinceOfThievesGameView extends OryxGameView {

    constructor(protected override readonly services: GameServices) {
        super(services);
    }
}